
export const getPostDate = (date) => {
    let f = new Date(date);
    return f.toLocaleDateString("de-DE", {
        year: "numeric",
        month: "long",
        day: "2-digit",
    }) 
}